import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const LoginPage = () => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const location = useLocation();

  const isLocalhost = window.location.hostname === 'localhost';
  const redirectTo = decodeURIComponent(
  new URLSearchParams(location.search).get('redirectTo') || '/'
);

  const iframeSrc = isLocalhost
    ? `http://localhost:3000/login?embed=true&source=npc`
    : `https://www.propsourcing.com.au/login?embed=true&source=npc`;

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === 'NPC_LOGIN_SUCCESS') {
        const { user, token } = event.data;

        if (token) {
          localStorage.setItem('npcAuthToken', token);
          localStorage.setItem('currentUser', JSON.stringify(user));
        }

        setLoginSuccess(true);
        setIframeLoaded(false);

        setTimeout(() => {
          window.location.href = redirectTo;
        }, 2000);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [redirectTo]);

  return (
    <div className="min-h-screen bg-white pt-8 pb-16 px-4">
      <div className="max-w-3xl mx-auto text-center mb-8">
        <h1 className="text-3xl font-bold text-[#003366]">
          Login to National Property Consultants
        </h1>
        <p className="text-gray-600 mt-2">Secure login powered by Propsourcing</p>
      </div>

      <div className="max-w-3xl mx-auto border rounded shadow relative overflow-hidden">
        {!iframeLoaded && !loginSuccess && (
          <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-[#003366] border-opacity-70"></div>
          </div>
        )}

        {!loginSuccess && (
          <iframe
            src={iframeSrc}
            title="Login - NPC"
            className={`w-full transition-opacity duration-500 ${
              iframeLoaded ? 'opacity-100' : 'opacity-0'
            }`}
            onLoad={() => setIframeLoaded(true)}
            style={{
              height: window.innerWidth < 640 ? '600px' : '700px',
              border: 'none',
            }}
          />
        )}

        {loginSuccess && (
          <div className="p-6 text-center">
            <h2 className="text-xl font-semibold text-green-600">✅ Login Successful</h2>
            <p className="mt-2 text-gray-600">Redirecting to your destination...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
